import {
  fetchPredictions as fetchAllPredictions,
  PLACES_TYPES,
} from '@sg/garnish';

import { getEnvVars } from '@order/utils';

import { type Location } from '../../LocationSearch.types';

// ─────────────────────────────────────────────────────────────────────────────

export async function fetchPredictions(searchString: string) {
  const { GOOGLE_API_KEY } = getEnvVars();

  const data = await fetchAllPredictions({
    input: searchString,
    apiKey: GOOGLE_API_KEY,
    placesTypes: [PLACES_TYPES.GEOCODE, PLACES_TYPES.ESTABLISHMENT],
  });

  return {
    predictions: data.predictions,
    locations: { pickup: LOCATIONS, outpost: LOCATIONS },
  };
}

const LOCATIONS: Location[] = [];
